import * as m from "@paraglide/messages"
import type { ContentImage } from "@site-types/content"
import type { HomeProps } from "@site-types/components/home"
import Agency from "./Agency"
import Brands from "./Brands"
import ScrollArrow from "./ScrollArrow"
import Stage from "./Stage"
import "./styles.css"
import { useRouteShellContext } from "@components/routeShellContext"

export function Home({ settings }: HomeProps) {
  const { locale } = useRouteShellContext()
  const graphicText = m.home_graphicText({}, { locale: locale }) ?? ""

  return (
    <div
      className="home-content"
      data-testid="home-content"
    >
      <section className="scroll-area">
        <Stage graphicText={graphicText} />
        <ScrollArrow
          href="#agency"
          label="Scroll to agency"
        />
      </section>
      <Agency
        gamersImage={settings.homePageGamersImage as ContentImage | undefined}
      />
      <Brands
        brandImage={settings.homePageBrandImage as ContentImage | undefined}
        settings={settings}
      />
    </div>
  )
}

export default Home
